<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
        v-if="roles !== undefined && roles.length !== 0">
        <div
            class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.roles.journey_schemas') }}</h5>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <SpinnerLoading v-if="journey_schemas === undefined" class="mt-50" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.title.label') }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                v-for="role in roles" :key="role.id">
                                {{ $t(`feature.roles.$type.${role.type}`) }}
                            </th>
                        </tr>
                    </thead>
                    <tbody> <!-- class="linked" -->
                        <tr v-for="schema in journey_schemas" :key="schema.id">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ schema.name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis"  v-for="role in roles" :key="role.id">
                                <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div>
                                        <SpinnerLoading class="h-auto" style="width: 30px;"
                                            v-if="loading_schema_id === schema.id + '_' + role.id" :small="true" />
                                            <div class="form-check form-group form-switch m-0" v-else>
                                                <input class="form-check-input shadow-none" type="checkbox"
                                                    role="switch" :checked="schema_has_role(schema, role)" :id="`${schema.id}-link`"
                                                    @change="($event) => updateSchema(schema, role, $event)">
                                            </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <AlertModal :id="`alertModalZoneSchemas_${zone_id}`" :title="$t('feature.roles.remind_journey_schemas.title')" :message="$t('feature.roles.remind_journey_schemas.message')"
        @close="alertModal?.hide()" />

</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import API from "@/services/api/api.service";
import { RoleInfo } from "@/utils/models/user.model";
import { AxiosResponse } from "axios";
import AlertModal from "@/components/Widgets/AlertModal.vue";
import { Modal } from "bootstrap";
import { JourneySchema } from "@/utils/models/journey.model";

type ZoneJourneySchemaOperation = (params: { schema_id: string | number, role_id: string | number }) => Promise<AxiosResponse<any, any>>;

export default defineComponent({
    name: 'ZoneJourneySchemas',
    components: {
        SpinnerLoading,
        AlertModal
    },
    props: {
        roles: {
            type: Array as PropType<RoleInfo[]>,
            required: false,
            default: () => ([]) as RoleInfo[]
        },
        zone_id: {
            type: [String, Number] as PropType<string | number>,
            required: true
        }
    },
    data: function () {
        return {
            journey_schemas: undefined as JourneySchema[] | undefined,
            loading_schema_id: undefined as number | string | undefined,
            alertModal: undefined as Modal | undefined,
            associations: false as Boolean
        }
    },
    async mounted() {
        this.alertModal = new Modal(`#alertModalZoneSchemas_${this.zone_id}`, {});
        await this.loadSchemas();
    },
    methods: {
        loadSchemas: async function () {
            this.journey_schemas = undefined;
            await API.getJourneySchemas().then((response) => {
                this.journey_schemas = response.data?.data ?? [];
            }).catch((error) => {
                this.journey_schemas = [];
            });

            this.associations = false; 
            let _ = (this.journey_schemas ?? [])!.some((schema: JourneySchema) => {
                const roles = this.roles.map(r => r.id.toString());
                return schema.roles.some(role_id => {
                    const includes = roles.includes(role_id);
                    if (includes) {
                        this.associations = true;
                        return roles.includes(role_id);
                    } else {
                        this.associations = false;
                    }
                });
            });
            if ((this.roles ?? []).length !== 0 && (this.associations === false)) {
                this.alertModal?.show();
            }

        },
        updateSchema(schema: JourneySchema, role: RoleInfo,  $event: Event) {
            this.loading_schema_id = schema.id + '_' + role.id;
            let api: ZoneJourneySchemaOperation;
            /* DELETE CONSENT */
            const store = ($event?.target && ($event.target as HTMLInputElement).checked) ?? false;
            if (store === false) {
                api = API.deleteRoleFromJourneySchema as ZoneJourneySchemaOperation;
            } else {
                api = API.storeRoleFromJourneySchema as ZoneJourneySchemaOperation;
            }
            
            api({ schema_id: schema.id, role_id: role.id }).then((response) => {
                if (response.data.success === true) {
                    if (store === false) {
                        schema.roles = schema.roles?.filter(r => r !== role.id.toString());
                    } else {
                        schema.roles = [...(schema.roles ?? []), role.id.toString() ];
                    }
                }
            }).finally(() => {
                this.loading_schema_id = undefined;
            }).catch((error) => {
                ($event.target as HTMLInputElement).checked = store
            });
        },

        schema_has_role: function(schema: JourneySchema, role: RoleInfo): boolean {
            return schema.roles?.some(r => r === role.id.toString()) ?? false;
        }
    }
});
</script>